<template>
	<div class='real-talk'>
		<CreatePost v-if="hasUserSubscriptions" :market='market' @create='handlePostCreate' />
		<Feed v-for='(feed, p) in value'
			:key='p'
			:feed='feed'
			:contactTypes='contactTypes'
			@update='updateHandle'
			@delete='$emit("delete",feed.id)'
			@comment-delete="$event=>handleCommentDelete($event,feed.id)"
		/>
	</div>
</template>

<script>
import CreatePost from './components/CreatePost/CreatePost.vue';
import Feed from './components/Feed/Feed.vue';
import api from '__jsVueApi';

export default {
	name:       'RealTalk',
	props: {
		market: {
			type:    [Boolean, Number],
			default: false
		},
		value: {
			type:    Array,
			default: () => []
		}
	},
	data() {
		return {
			hasUserSubscriptions: false,
			contactTypes: 	       {}
		};
	},
	async mounted() {
		await this.$store.dispatch('profile/getProfile');
		await axios.get(api.contacts.getTypes).then((response) => {
			this.contactTypes = response.data;
		});
		this.hasUserSubscriptions = !!this.$store.state.profile.profile.has_active_subscription;
	},
	components: {
		Feed,
		CreatePost
	},
	methods: {
		updateHandle(post) {
			this.$emit('update');
		},
		handlePostCreate(feed) {
			let copy = [...this.value];
			feed.item_type = 'post';
			copy.unshift(feed);
			this.$emit('input', copy);
		},
		handleCommentDelete(id, feedId) {
			this.$emit('comment-delete', { commentId: id, feedId });
		}
	}
};
</script>
